export default __webpack_public_path__ + "static/media/account-icon.881667cb.svg";